import React, { useState } from 'react';
import { motion } from 'framer-motion';
import AuditDetailPage from './AuditDetail';
import SubmitReportPage from './SubmitReport';
import ClosurePage from './ClosurePage';

const tabs = ['Checklist', 'Report', 'Closure'];

const AuditTogglePage = () => {
  const [activeTab, setActiveTab] = useState('Checklist');

  const renderContent = () => {
    switch (activeTab) {
      case 'Checklist':
        return <AuditDetailPage />;
      case 'Report':
        return <SubmitReportPage />;
      case 'Closure':
        return <ClosurePage />;
      default:
        return null;
    }
  };

  return (
    <div className="p-2">
      {/* Toggle Navbar */}
      <div className="flex space-x-4 mb-6">
        {tabs.map((tab) => (
          <button
            key={tab}
            onClick={() => setActiveTab(tab)}
            className={`px-4 py-2 rounded-xl transition-all text-sm font-medium ${
              activeTab === tab
                ? 'bg-blue-600 text-white shadow-lg'
                : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
            }`}
          >
            {tab}
          </button>
        ))}
      </div>

      {/* Page Content */}
      <motion.div
        key={activeTab}
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.3 }}
        className="bg-white p-6 rounded-xl shadow-md border"
      >
        {renderContent()}
      </motion.div>
    </div>
  );
};



export default AuditTogglePage;
